// extracted by mini-css-extract-plugin
export default {"nav-tab":"MultiTab_nav-tab__3eVv3","main-content":"MultiTab_main-content__hfeTH","left":"MultiTab_left__q6g5o","right":"MultiTab_right__1D0HB","selected":"MultiTab_selected__gMFBO"};